package com.yendo.mx.repository

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.functions.functions
import kotlinx.serialization.Serializable
import com.yendo.mx.utils.redondear

// --- MOLDES PARA AJUSTE Y CAPTURA FINAL ---
@Serializable
data class AjusteResponse(
    val success: Boolean,
    val error: String? = null,
    val idTransaccion: String? = null,
    val idTransaccionOriginal: String? = null,
    val idTransaccionExtra: String? = null
)

// --- MOLDES PARA GUARDAR TARJETA ---
@Serializable
data class GuardarTarjetaRequest(
    val tokenCard: String,
    val email: String
)

@Serializable
data class GuardarTarjetaResponse(
    val success: Boolean,
    val cardId: String? = null,
    val error: String? = null,
    val terminacion: String? = null,
    val marca: String? = null,
    val issuerId: String? = null, // 🚀 NUEVO
    val details: String? = null
)

// --- MOLDES PARA CHECKOUT SEGURO ---
@Serializable
data class CheckoutItemRequest(
    val idProducto: String,
    val cantidad: Double,
    val adicionales: List<String>,
    val notas: String
)

@Serializable
data class CheckoutUbicacionRequest(
    val latitude: Double,
    val longitude: Double,
    val direccion: String,
    val tipoUbicacion: String,
    val opcionEntrega: String,
    val indicaciones: String
)

@Serializable
data class CheckoutRequest(
    val items: List<CheckoutItemRequest>,
    val idRestaurante: String,
    val idZona: String,
    val ubicacionEntrega: CheckoutUbicacionRequest,
    val ubicacionNegocio: CheckoutUbicacionRequest? = null,
    val costoEnvio: Double = 0.0,
    val tarifaServicio: Double = 0.0,
    val metodoPago: String,
    val idTarjetaSeleccionada: String? = null,
    val tokenPagar: String? = null,
    val propina: Double,
    val idCupon: String? = null,
    val tipoPedido: String,
    val esProgramado: Boolean,
    val fechaProgramada: Long? = null,
    val conCuantoPaga: Double? = null,
    val accionAgotado: String,
    val nombreCliente: String,
    val apellidoCliente: String,
    val emailCliente: String,
    val telefonoCliente: String,
    val issuerId: String? = null
)

@Serializable
data class CheckoutResponse(
    val success: Boolean,
    val idPedido: String? = null,
    val error: String? = null
)

object PagosRepository {

    suspend fun finalizarPedidoSeguro(request: CheckoutRequest): String? {
        return try {
            val callable = Firebase.functions.httpsCallable("finalizarPedidoSeguro")
            val resultado = callable.invoke(request)
            val data = resultado.data<CheckoutResponse>()
            if (data.success) data.idPedido else {
                println("YENDO_ERROR: El servidor rechazó el checkout: ${data.error}")
                null
            }
        } catch (e: Exception) {
            println("YENDO_ERROR: Falló la conexión con finalizarPedidoSeguro: ${e.message}")
            null
        }
    }

    suspend fun guardarTarjetaEnNube(tokenCard: String, email: String): Pair<String?, String?> {
        return try {
            val callable = Firebase.functions.httpsCallable("guardarTarjetaEnCustomer")

            // 🚀 CORRECCIÓN: Enviamos un mapa nativo en lugar de una data class para evitar errores de serialización
            val requestPayload = mapOf(
                "tokenCard" to tokenCard,
                "email" to email
            )

            val resultado = callable.invoke(requestPayload)
            val data = resultado.data<GuardarTarjetaResponse>()

            if (data.success) {
                // Retornamos el cardId y el issuerId
                Pair(data.cardId, data.issuerId)
            } else {
                println("YENDO_ERROR: El servidor rechazó guardar la tarjeta: ${data.error}")
                Pair(null, null)
            }
        } catch (e: Exception) {
            println("YENDO_ERROR: Falló la conexión con la función guardarTarjeta: ${e.message}")
            Pair(null, null)
        }
    }

    suspend fun procesarAjusteYCapturaFinal(idPedido: String, nuevoTotal: Double, nuevoTokenExtra: String? = null): Boolean {
        return try {
            val callable = Firebase.functions.httpsCallable("procesarAjusteYCapturaFinal")
            val request = mapOf(
                "idPedido" to idPedido,
                "nuevoTotal" to redondear(nuevoTotal),
                "nuevoTokenExtra" to nuevoTokenExtra
            )
            val resultado = callable.invoke(request)
            val data = resultado.data<AjusteResponse>()
            data.success
        } catch (e: Exception) {
            println("YENDO_ERROR: Falló procesarAjusteYCapturaFinal: ${e.message}")
            false
        }
    }
}
